
/**
 * Helper functions for program operations
 */

/**
 * Calculate the next update due date based on program duration
 */
export const calculateNextUpdateDue = (duration: string) => {
  const weeks = parseInt(duration, 10) || 4;
  const date = new Date();
  date.setDate(date.getDate() + (weeks * 7)); // Add weeks to current date
  return date.toISOString();
};

/**
 * Format program data for AI model consumption
 */
export const formatProgramDataForAI = (
  programData: any,
  tierData: any,
  preferencesData: any,
  userId: string,
  selectedClient: { id: string; name: string; avatar: string }
) => {
  // Enhanced periodization data extraction
  const periodizationExperience = 
    tierData.hasPeriodizationExperience === "yes" ? "experienced" :
    tierData.hasPeriodizationExperience === "no" ? "none" : "unknown";

  // Convert duration to weeks explicitly
  const durationWeeks = parseInt(programData.duration) || 4;
  const daysPerWeek = parseInt(programData.daysPerWeek) || 3;
  
  // Structure the program data for AI model consumption
  return {
    name: programData.programName,
    tier: programData.tier,
    duration: programData.duration || "4",
    durationWeeks: durationWeeks,
    daysPerWeek: daysPerWeek,
    startDate: programData.startDate || new Date().toISOString().split('T')[0],
    created_at: new Date().toISOString(),
    created_by: userId,
    description: programData.description || "",
    
    medicalInfo: {
      conditions: programData.medicalConditions === "yes" ? [programData.medicalDetails || ""] : ["none"],
      injuries: programData.injuries ? [programData.injuries] : [],
    },
    
    trainingFrequency: {
      daysPerWeek: daysPerWeek,
    },
    
    periodization: {
      experience: periodizationExperience,
      approach: tierData.periodizationApproach || "",
    },
    
    performance: {
      tracking: tierData.performanceTracking || "",
      recentAchievements: tierData.recentPerformance || "",
      weaknesses: tierData.weaknesses || "",
    },
    
    preferences: preferencesData ? {
      likedExercises: preferencesData.likedExercises || [],
      dislikedExercises: preferencesData.dislikedExercises || [],
    } : {},
    
    assigned_clients: [{
      id: selectedClient.id,
      name: selectedClient.name,
      avatar: selectedClient.avatar
    }]
  };
};

/**
 * Clean tier data by removing undefined or null values
 */
export const cleanTierData = (tierData: any) => {
  const cleanedTierData = { ...tierData };
  
  // Remove any undefined or null values
  Object.keys(cleanedTierData).forEach(key => {
    if (cleanedTierData[key] === undefined || cleanedTierData[key] === null) {
      delete cleanedTierData[key];
    }
  });
  
  return cleanedTierData;
};
